import classNames from "classnames";
import { useMemo } from "react";
import styles from "./skeleton.module.less";

export default function MasonrySkeleton({
  columnNum,
  columnSize,
  gutter,
  hideText = false,
  radius = 12,
}) {
  const cols = useMemo(() => {
    // 预设的随机高度
    const heights = [
      [242, 329, 278, 355],
      [329, 278, 355, 242],
      [400, 242, 329, 278],
      [278, 242, 329, 355],
      [200, 355, 278, 329],
    ];

    return Array.from({ length: columnNum }).map((_, i) => {
      return Array.from({ length: 4 }).map((_, ii) => {
        return (
          <div
            key={i + "-" + ii}
            className={classNames(styles.skeletonItem, {
              [styles.staggered]: i % 2,
            })}
            style={{ width: columnSize }}
          >
            <div
              className={styles.imageplaceholder}
              style={{ height: heights[i % 5][ii], borderRadius: radius }}
            />
            {!hideText && (
              <div
                className={styles.textplaceholder}
                style={{ borderRadius: radius }}
              />
            )}
            {/* <div className={`${styles.textplaceholder} ${styles.short}`} /> */}
          </div>
        );
      });
    });
  }, [columnNum]);

  return (
    <div className={styles.masonryGrid} style={{ gap: gutter }}>
      {cols.map((colArr, index) => {
        return (
          <div className={styles.col} key={index} style={{ gap: gutter }}>
            {colArr}
          </div>
        );
      })}
    </div>
  );
}
